import React from 'react';
import LogoLight from '../../icons/logo-light.svg?react';
import LogoDark  from '../../icons/logo-dark.svg?react';

type LogoVariant = 'icon' | 'text' | 'full';

interface PrismancyLogoProps {
  variant?: LogoVariant;
  className?: string;
}

const logoTextStyle: React.CSSProperties = {
  fontFamily: "'Manrope', sans-serif",
  fontWeight: 500,
  fontSize: '22px',
  lineHeight: '100%',
  letterSpacing: '-0.05em',
  color: 'var(--ui-logo)',
};

const PrismancyLogo: React.FC<PrismancyLogoProps> = ({
  variant = 'full',
  className = '',
}) => {
  const showIcon = variant === 'icon' || variant === 'full';
  const showText = variant === 'text' || variant === 'full';

  // icon-only: 28×28 | full (with text): match text size (~22px)
  const iconSize = variant === 'icon' ? 28 : 22;

  return (
    <span className={`inline-flex items-center gap-[4px] ${className}`}>
      {showIcon && (
        <>
          <LogoLight width={iconSize} height={iconSize} className="icon-light shrink-0" />
          <LogoDark  width={iconSize} height={iconSize} className="icon-dark  shrink-0" />
        </>
      )}
      {showText && (
        <span style={logoTextStyle}>Prismancy</span>
      )}
    </span>
  );
};

export default PrismancyLogo;
